import React from 'react';
import { FreeFocusInside } from 'react-focus-lock';
import ConfirmDialog from 'chameleon/ui-stack/ui/modals/confirm-dialog';

const MustAssignInfoModal = (props) => {
  const { onHandleShowMustAssignInfoModal } = props;
  return (
    <FreeFocusInside>
      <ConfirmDialog
        wrapperClassName="!min-w-fit"
        size="tiny"
        onSuccess={onHandleShowMustAssignInfoModal}
        onClose={onHandleShowMustAssignInfoModal}
        content={{
          btnPrimary: 'OK',
        }}
      >
        <p className="must-assign-info-text">
          Assignments must include at least one student or class. If you wish to
          delete this assignment completely, you can delete this assignment on
          the assignment page.
        </p>
      </ConfirmDialog>
    </FreeFocusInside>
  );
};

export default MustAssignInfoModal;
